import { render, staticRenderFns } from "./DemoPage.vue?vue&type=template&id=2ebe8827&scoped=true&"
import script from "./DemoPage.vue?vue&type=script&lang=ts&"
export * from "./DemoPage.vue?vue&type=script&lang=ts&"
import style0 from "./DemoPage.vue?vue&type=style&index=0&id=2ebe8827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe8827",
  null
  
)

export default component.exports